import sdkInstanceManager from './../managers/sdk-instance-manager';

export type InitialiseOptions = { baseUrl?: string };

export const initialise = (apiKey: string, options?: InitialiseOptions) => {
  try {
    sdkInstanceManager.initialise(apiKey, options);
    return true;
  } catch (e) {
    console.info((e as any)?.message);
    return false;
  }
};
